import React from 'react';

import {
  Box,
  FormControlLabel,
  Grid,
  styled,
  Switch,
  Typography
} from '@mui/material';
import _ from 'lodash';
import { LoadingBox } from 'modules';

import { PitchDeckTopicAccordion } from './components/PitchDeckTopicAccordion';
import * as dataService from './dataService';



const SwitchBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBottom: 72
});

const SwitchLabel = styled(Typography)({
  color: '#C3D1D8',
  fontSize: 14
});

const PitchDeckTopicBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '64px'
});

const PitchDeckTopicGrid = styled(Grid)({
  minWidth: '270px'
});



export const PitchDeckTopicSection: React.FC = () => {
  const { data, loading } = dataService.usePitchDeckTopicSection();

  const [isExpanded, setIsExpanded] = React.useState(false);

  const combinedColumns = React.useMemo(() => {
    const pitchDeckTopicAccordions = _.map(data, d => (
      <Grid item key={d.id}>
        <PitchDeckTopicAccordion
          isExpanded={isExpanded}
          title={d.title}
          content={d.bodyText}
          seeExamplesLink={d.link}
        />
      </Grid>
    ));

    const firstHalfOfColumns = __splitIntoGroupsOf<JSX.Element>(5, pitchDeckTopicAccordions, [0, 10]);
    const secondHalfOfColumns = __splitIntoGroupsOf<JSX.Element>(4, pitchDeckTopicAccordions, 10);
    return _.concat([], firstHalfOfColumns, secondHalfOfColumns);

  }, [data, isExpanded]);



  return (
    <>
      <SwitchBox>
        <FormControlLabel
          control={<Switch />}
          onChange={(_, checked) => setIsExpanded(checked)}
          label={<SwitchLabel>Expand All</SwitchLabel>}
          labelPlacement='start'/>
      </SwitchBox>

      <LoadingBox.FC active={loading} darkTheme/>

      <PitchDeckTopicBox>
        {!loading && _.map(combinedColumns, (column, i) => (
          <PitchDeckTopicGrid
            key={i}
            container
            direction="column"
            spacing={4}>
            {column}
          </PitchDeckTopicGrid>
        ))}
      </PitchDeckTopicBox>
    </>
  );
};



function __splitIntoGroupsOf<T>(items: number, collection: T[], slice: [number, number] | number) {
  if (typeof slice === 'number') {
    return _.chunk( _.slice(collection, slice), items);

  }

  return _.chunk(_.slice(collection, _.first(slice), _.last(slice)), items);
}
